"use strict";
const IpcProvider = null;
export { IpcProvider };
//# sourceMappingURL=ipc-provider.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ethersproject/providers/lib.esm/ipc-provider.js
// module id = 149
// module chunks = 0